import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import "./styles.scss";
import Input from "../../components/common/Input";
// import { isEmpty } from "../../utils/utils";
import Button from "../../components/common/Button";
import { Auth } from "aws-amplify";
import Loading from "../../components/Loading/Loading";

import { CONSTANTES } from "../../utils/Constantes";
import { callService } from "../../amplify/callService";

// TODO: configurar globalmente

const SendCodePassword = ({ data, handleCancel, handleConfirm }) => {
  const [localUser, setLocalUser] = useState("");
  const [validationMessage, setValidationMessage] = useState("");
  const [validationOk, setValidationOk] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (data?.username?.trim()) setLocalUser(data?.username?.trim());
  }, [data]);

  const handleLoading = (value) => setLoading(value);

  const handleUserChange = (value) => {
    setLocalUser(value);
    setValidationMessage("");
    setValidationOk(false);
  };

  const handleCode = async (e) => {
    const body = {
      payload: {
        username: localUser.trim()
      },
    };
    let mensaje = "";
    try {
      handleLoading(true);
      const response = await callService(
        "POST",
        CONSTANTES.APIS_PATH.forgotPassword,
        body
      );
      handleLoading(false);
      // type == 0 => ok , type == 1 => error
      let error = response.data ? response.data.type : null;
      debugger;
      if (response.ok && response.data && response.ok == true && error != '1') {
        const mesaje = response.message || "OK";
        mensaje = response.data.data.message || response.message || "Los datos ingresados son incorrectos, por favor verifícalos y vuelve a intentar";
        if (response.data.data.valid == true) {

          try {
            e.preventDefault();
            handleLoading(true);
            console.log(localUser);
            let responseAuth = await Auth.forgotPassword(localUser);
            handleLoading(false);
            setValidationOk(true);
            setValidationMessage(
              "El código fue generado y enviado con exito al correo: " +
              responseAuth.CodeDeliveryDetails.Destination
            );
            handleConfirm();
          } catch (error) {
            handleLoading(false);
            setValidationOk(true);
            if ("UserNotConfirmedException" === error.code) {
              setValidationMessage(
                "Usuario requiere confirmación del registro antes de Loguear"
              );
            } else if ("PasswordResetRequiredException" === error.code) {
              setValidationMessage("Se requiere restablecer la contraseña");
            } else if ("NotAuthorizedException" === error.code) {
              setValidationMessage("Contraseña inválida");
            } else if ("UserNotFoundException" === error.code) {
              setValidationMessage("Usuario no existe");
            } else if ("InvalidPasswordException" === error.code) {
              setValidationMessage("El formato de contraseña es inválido.");
            } else if ("LimitExceededException" === error.code) {
              setValidationMessage(
                "Se ha excedido el límite de intentos, intente después de un tiempo."
              );
            } else {
              setValidationMessage(
                "Ocurrió un error al autenticar. Contacte al administrador"
              );
            }
          }
        }
        else
        {
          setValidationMessage(
            mensaje
          );
        }

      } else {
        mensaje = response.message || "Error al registrar";
        //mensaje = "Los datos ingresados son incorrectos, por favor verifícalos y vuelve a intentar";

        setValidationMessage(
          mensaje
        );
      }
    } catch (ex) {
      console.log(ex)
      handleLoading(false);
      mensaje = "Los datos ingresados son incorrectos, por favor verifícalos y vuelve a intentar";
      
      setValidationMessage(
        mensaje
      );
    }


  };

  return (
    <div className="codepassword-layout">
      <div>
        <p className="title-04">Hola!</p>
        <p className="title-07">Generar Código para restablecer contraseña</p>
        <p className="title-08">
          El código será enviado al correo asociado a este usuario
        </p>
        <Input
          label="Usuario"
          value={localUser}
          onChange={(newValue) => handleUserChange(newValue)}
        />
        {validationMessage && (
          <span className={validationOk ? "message-success" : "message-error"}>
            * {validationMessage}
          </span>
        )}
        <div className="codepassword-layout__btns d-flex w100">
          <div className="w40">
            <Button primary text="Generar Codigo" onClick={handleCode} />
          </div>
          <div className="w40">
            <Button secondary text="Cancelar" onClick={handleCancel} />
          </div>
        </div>
      </div>
      {loading && <Loading />}
    </div>
  );
};

SendCodePassword.propTypes = {
  data: PropTypes.object,
  handleCancel: PropTypes.func,
  handleConfirm: PropTypes.func,
};

SendCodePassword.defaultProps = {
  data: {},
  handleCancel: null,
  handleConfirm: null,
};

export default SendCodePassword;
